module.exports = __webpack_public_path__ + "img/heroku.732eda67.png";